import { http } from './client'

interface OpenApiInfo {
  info?: { version?: string }
}

export async function getApiVersion(): Promise<string> {
  const spec = await http.get<OpenApiInfo>('/openapi.json', { skipAuth: true })
  return spec.info?.version ?? ''
}
